import apiClient from './apiClient';

export interface GEXStrike {
  strike: number;
  call_gex: number;
  put_gex: number;
  net_gex: number;
}

export interface GEXData {
  ticker: string;
  strikes: GEXStrike[];
  gamma_flip: number | null;
  max_pain: number | null;
  spot_price: number | null;
  available_expiries: string[];
  expiry_max: string;
}

export const gexService = {
  getGEX: (ticker: string, expiryMax?: string, rangePct?: number) => {
    const params: Record<string, string | number> = {};
    if (expiryMax) params.expiry_max = expiryMax;
    if (rangePct !== undefined) params.range_pct = rangePct;
    return apiClient
      .get<GEXData>(`/api/discover/gex/${ticker}`, {
        params: Object.keys(params).length ? params : undefined,
      })
      .then((r) => r.data);
  },
};
